import apiClient from './Request'
import { baseUrls } from './../const'

export default {
  getPatients(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/Board/GetPatient?userId=' + id
    )
  },
  LatestPodChartDataPoint(podMac) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/Data/LatestPodChartDataPoint?podMac=' +
        podMac
    )
  },
  LatestRecords() {
    return apiClient.get(baseUrls['commonBaseUrl'] + '/Data/LatestRecords')
  },
  FetchStreamPodData(macFilter, startTime, endTime, utcOffset) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/data/getdataforstream?macFilter=' +
        macFilter +
        '&startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&inputUtcOffset=' +
        utcOffset +
        '&outputUtcOffset=' +
        utcOffset
    )
  },
  GetGroupedData(macFilter, startTime, endTime, inputUtcOffset) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/data/GetGroupedData?macFilter=' +
        macFilter +
        '&startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&inputUtcOffset=' +
        inputUtcOffset
    )
  },
  LatestCaliPodChartDataPoint(podMac) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/data/LatestCaliPodChartDataPoint?podMac=' +
        podMac
    )
  },
  SendEventData(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/eventhub/sendeventdata',
      data: data
    })
  },
  AddToGroup(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['signalRUrl'] + '/AddToGroup',
      data: data
    })
  }
}
